// extracted by mini-css-extract-plugin
export default {"blogTitle":"style_blogTitle__PKmnw","blogContent":"style_blogContent__pUnxA","imgs":"style_imgs__P0LhG","auction":"style_auction__cmtKZ","twoCol":"style_twoCol__owlK5"};